var map = {
	"./20130613_403944_598294.mp3": 1807,
	"./20130613_660275_347281.mp3": 1808,
	"./20130613_838018_933669.mp3": 1809,
	"./20150430_007032_084509.mp3": 1810,
	"./20150430_033549_589817.mp3": 1811,
	"./20150508_632870_571715.mp3": 1812,
	"./20150518_005438_322435.mp3": 1813,
	"./20150616_764458_322533.mp3": 1814,
	"./20150630_472842_529425.mp3": 1815,
	"./bgm/01zzaz.mp3": 1299,
	"./bgm/02piano.mp3": 1300,
	"./bgm/03easy.mp3": 1301,
	"./bgm/04country.mp3": 1302,
	"./bgm/05classic.mp3": 1303,
	"./converted_rec_05073493318_01062064378_20200323152710.wav": 1816,
	"./file_example_WAV_1MG.wav": 1817,
	"./rec_05073493318_01062064378_20200323152710.wav": 1818,
	"./tone/bright.mp3": 1296,
	"./tone/normal.mp3": 1297,
	"./tone/placid.mp3": 1298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1806;